import React from 'react';
interface Props {
  fillColor?: string;
}
function HealthManagementIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none">
      <g clipPath="url(#clip0_851_3387)">
        <path
          d="M7 4.25H7.5C8.88125 4.25 10 3.13125 10 1.75V1.25C10 0.975 9.775 0.75 9.5 0.75H9C7.61875 0.75 6.5 1.86875 6.5 3.25V3.75C6.5 4.025 6.725 4.25 7 4.25ZM1.5 9.75C1.5 8.75937 1.7375 7.79688 2.1375 7.13438C2.51562 6.50938 2.95937 6.25 3.5 6.25C4.05625 6.25 4.85 6.48125 5.54063 6.75C6.47813 7.11562 7.525 7.11562 8.4625 6.75C9.15312 6.48125 9.94688 6.25 10.5031 6.25C11.0437 6.25 11.4875 6.50938 11.8656 7.13438C12.2625 7.79688 12.5 8.75937 12.5 9.75C12.5 11.4438 11.9688 12.875 11.2375 13.85C10.4875 14.85 9.6375 15.25 9 15.25C8.85625 15.25 8.575 15.1969 8.22188 15.0906C7.42813 14.8531 6.575 14.8531 5.78125 15.0906C5.42812 15.1969 5.14688 15.25 5.00313 15.25C4.36563 15.25 3.51562 14.85 2.76562 13.85C2.03125 12.875 1.5 11.4438 1.5 9.75ZM3.5 4.75C1.11562 4.75 0 7.36562 0 9.75C0 13.75 2.5 16.75 5 16.75C5.37187 16.75 5.82812 16.6438 6.2125 16.5281C6.725 16.375 7.27813 16.375 7.79063 16.5281C8.17188 16.6438 8.62813 16.75 9.00313 16.75C11.5031 16.75 14.0031 13.75 14.0031 9.75C14.0031 7.36562 12.8875 4.75 10.5031 4.75C9.65 4.75 8.6375 5.07188 7.91875 5.35313C7.33125 5.58125 6.67188 5.58125 6.08437 5.35313C5.36562 5.07188 4.35313 4.75 3.5 4.75Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3387">
          <rect
            width="14"
            height="16"
            fill="white"
            transform="translate(0 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default HealthManagementIcon;
